import { Printer } from "lucide-react";
import { periodLabel, rupiah } from "../lib/api";
import { Modal } from "./Common";
import { printSheet } from "./Certificate";
import { useSite } from "../lib/site";

const UNITS = ["", "satu", "dua", "tiga", "empat", "lima", "enam", "tujuh", "delapan", "sembilan", "sepuluh", "sebelas"];
export function terbilang(n) {
  n = Math.floor(n);
  if (n < 12) return UNITS[n];
  if (n < 20) return `${terbilang(n - 10)} belas`;
  if (n < 100) return `${terbilang(Math.floor(n / 10))} puluh ${terbilang(n % 10)}`.trim();
  if (n < 200) return `seratus ${terbilang(n - 100)}`.trim();
  if (n < 1000) return `${terbilang(Math.floor(n / 100))} ratus ${terbilang(n % 100)}`.trim();
  if (n < 2000) return `seribu ${terbilang(n - 1000)}`.trim();
  if (n < 1e6) return `${terbilang(Math.floor(n / 1000))} ribu ${terbilang(n % 1000)}`.trim();
  if (n < 1e9) return `${terbilang(Math.floor(n / 1e6))} juta ${terbilang(n % 1e6)}`.trim();
  return `${terbilang(Math.floor(n / 1e9))} miliar ${terbilang(n % 1e9)}`.trim();
}

export function ReceiptModal({ invoice, close }) {
  const S = useSite();
  const number = `KHA/KW/${invoice.period.replace("-", "")}/${invoice.id.slice(0, 6).toUpperCase()}`;
  const paidAt = invoice.paid_at ? new Date(invoice.paid_at).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }) : "-";
  return <Modal title="Kuitansi pembayaran" close={close}>
    <div className="receipt-sheet printable" data-testid="receipt-sheet">
      <div className="receipt-head"><img src="/kha-emblem.png" alt="KHA" /><div><strong>KHOLID ARCHERY ACADEMY</strong><small>{S.address} · {S.whatsapp} · {S.email}</small></div><div className="receipt-no"><span>KUITANSI</span><b data-testid="receipt-number">{number}</b></div></div>
      <div className="receipt-body">
        <div className="receipt-line"><span>Telah diterima dari</span><b data-testid="receipt-athlete">{invoice.athlete_name}</b></div>
        <div className="receipt-line"><span>Untuk pembayaran</span><b>{invoice.type} · {periodLabel(invoice.period)}{invoice.description ? ` — ${invoice.description}` : ""}</b></div>
        <div className="receipt-line"><span>Metode</span><b>{invoice.method}{invoice.note ? ` · ${invoice.note}` : ""}</b></div>
        <div className="receipt-line"><span>Tanggal bayar</span><b>{paidAt}</b></div>
        <div className="receipt-words"><span>Terbilang</span><em>{terbilang(invoice.amount)} rupiah</em></div>
      </div>
      <div className="receipt-foot"><div className="receipt-amount" data-testid="receipt-amount">{rupiah(invoice.amount)}</div><div className="receipt-stamp"><span>LUNAS</span></div><div className="receipt-sign"><small>{S.city}, {paidAt}</small><div className="sign-line" /><b>{invoice.recorded_by || "Admin KHA"}</b><small>Bendahara KHA</small></div></div>
    </div>
    <div className="modal-actions"><button type="button" className="outline-btn" onClick={close} data-testid="receipt-close-button">Tutup</button><button className="primary-btn" onClick={printSheet} data-testid="receipt-print-button"><Printer size={15} /> Cetak kuitansi</button></div>
  </Modal>;
}
